module.exports = __webpack_public_path__ + "static/media/tops2.968dd78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tops2.png
// module id = 1865
// module chunks = 0 1